import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { Tracking } from "../../../services/Tracking";

export const useInvoiceV2 = () => {
  const { uuidAgendamento } = useParams();

  const { data: agendamento, isError: isAgendamentoError } =
    useAgendamentoPorId(uuidAgendamento ?? "");
  const { data: fatura, isError: isFaturaError } = useConsultarFatura(
    uuidAgendamento ?? "",
  );

  const pagamento = fatura?.content?.find(
    (f) => f.status === StatusPagamentoEnum.pending,
  );

  const isPix = !!pagamento?.pix?.qrcode;
  const isBoleto = !isPix && !!pagamento?.boleto?.barCode;

  const contaIugu = agendamento?.loja
    ? agendamento?.loja?.contaIugu
    : agendamento?.delivery?.contaIugu;

  useEffect(() => {
    if (!isAgendamentoError) return;
    Tracking.error("mapa:agendamento/fatura:buscar-agendamento-falhou");
  }, [isAgendamentoError]);

  useEffect(() => {
    if (!isFaturaError) return;
    Tracking.error("mapa:agendamento/fatura:buscar-fatura-falhou");
  }, [isFaturaError]);

  function handlePrint() {
    Tracking.userAction("mapa:agendamento/fatura:clique-imprimir-fatura");
    window.print();
  }

  return {
    agendamento,
    pagamento,
    contaIugu,
    isPix,
    isBoleto,
    handlePrint,
  };
};
